// let f_questions = document.querySelectorAll(".faq-questions");
// f_questions.forEach((f_questions) => {
//   f_questions.addEventListener("click", (event) => {
//     const active = document.querySelector(".faq-questions.active");
//     if (active && active !== f_questions) {
//       active.classList.toggle("active");
//       active.nextElementSibling.style.maxHeight = 0;
//     }
//     f_questions.classList.toggle("active");
//     const answers = f_questions.nextElementSibling;
//     if (f_questions.classList.contains("active")) {
//       answers.style.maxHeight = answers.scrollHeight + "px";
//     } else {
//       answers.style.maxHeight = 0;
//     }
//   });
// });



// Select all elements with the class 'faq-questions'
let f_questions = document.querySelectorAll(".faq-questions");

// Function to set the first FAQ item as open by default
function openFirstFAQ() {
  if (f_questions.length > 0) {
    const firstQuestion = f_questions[0];
    const firstAnswer = firstQuestion.nextElementSibling;
    firstQuestion.classList.add("active");
    firstAnswer.style.maxHeight = firstAnswer.scrollHeight + "px";
  }
}

// Iterate over each question element and add click event listener
f_questions.forEach((f_question) => {
  f_question.addEventListener("click", (event) => {
    // Find the currently active question element, if any
    const active = document.querySelector(".faq-questions.active");

    // If there is an active question and it's not the one just clicked, deactivate it
    if (active && active !== f_question) {
      active.classList.toggle("active");  // Remove 'active' class from the previously active question
      active.nextElementSibling.style.maxHeight = 0;  // Collapse the previously active answer
    }

    // Toggle the 'active' class on the clicked question
    f_question.classList.toggle("active");

    // Get the answer element that follows the clicked question
    const answers = f_question.nextElementSibling;

    // If the clicked question is now active, expand the answer; otherwise, collapse it
    if (f_question.classList.contains("active")) {
      answers.style.maxHeight = answers.scrollHeight + "px";  // Expand the answer smoothly
    } else {
      answers.style.maxHeight = 0;  // Collapse the answer
    }
  });
});

// Open the first FAQ item by default when the page loads
openFirstFAQ();
